var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PreLoginView',[_c('PreLoginForm',{attrs:{"title":"CREATE_ACCOUNT"}},[(_vm.region)?_c('SignupForm',{attrs:{"errors":_vm.errors,"loading":_vm.loading},on:{"submit":_vm.submit}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }